// extracted by mini-css-extract-plugin
module.exports = {"container":"EducationDegree_container__2Dp7I","title":"EducationDegree_title__DlbHl"};